import { render, staticRenderFns } from "./ThreatRadar.vue?vue&type=template&id=3c635c48"
import script from "./ThreatRadar.vue?vue&type=script&lang=js"
export * from "./ThreatRadar.vue?vue&type=script&lang=js"
import style0 from "./ThreatRadar.vue?vue&type=style&index=0&id=3c635c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports